import React, { useState } from "react";
import "./Banner.css";
import axios from "axios";
import Red_Btn from "../../common_components/common_btn/red_btn/Red_Btn";
import Enquiry_Form_Modal from "../../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal";

function Banner() {

  const [showModal, setShowModal] = useState(false)

  return (
    <section className="Banner">
      <div className="container-fluid p-0">
        <div className="banner_holder">
          <img src="/assets/images/home/banner/banner.png" className="banner_img" />


          <div className="btn_holder">
            <Red_Btn btn_name="Enquire Now" onClick={() => { setShowModal(true) }} />
          </div>

        </div>
      </div>

      <Enquiry_Form_Modal
        show={showModal}
        onHide={() => { setShowModal(false) }}
      />

    </section>
  );
}

export default Banner;
